import { useDispatch, useSelector } from 'react-redux';
import CountTopFilter from '../../common/CountTopFilter';
import DateRange from '../../common/DateRange/DateRange';
import Panel from '../../common/Panel';
import Wall from '../../common/Wall';
import ActionButton from '../../common/ActionButton';
import DropDownFilter from '../../filters/DropDownFilter';
import {
  dropshipOrdersReport,
  getDropshipOrders,
  setDropshipOrdersLoading,
  setDropshipOrdersSupplierId,
} from '../../../store/actions/dropshipOrders';
import { setDropshipOrdersLastDayFilter } from '../../../store/actions/pageFilters';

export function RetailerDropshipOrdersPanel() {
  const dispatch = useDispatch();
  const { retailerSuppliers } = useSelector((state) => state.role);
  const { count, pendingCount, completedCount, canceledCount, activeCount } = useSelector(
    (state) => state.dropshipOrders,
  );

  const handleChangeRange = (startDate, endDate) => {
    dispatch(setDropshipOrdersLoading(true));
    dispatch(setDropshipOrdersLastDayFilter(startDate, endDate));
  };

  const getOrders = (title) => dispatch(getDropshipOrders(title));

  const suppliers = [
    {
      value: '',
      label: 'All Sellers',
    },
    ...retailerSuppliers.map((retailerSupplier) => ({
      value: retailerSupplier.supplier.id,
      label: retailerSupplier.supplier.name,
      image: retailerSupplier.supplier.square_logo_path,
    })),
  ];

  return (
    <Panel fix>
      <Wall />

      <DateRange onChange={(startDate, endDate) => handleChangeRange(startDate, endDate)} />
      <Wall />

      <CountTopFilter onClick={getOrders} title="ALL" count={count} activeCount={activeCount} />
      <CountTopFilter onClick={getOrders} title="PROCESSING" count={pendingCount} activeCount={activeCount} />
      <CountTopFilter onClick={getOrders} title="COMPLETED" count={completedCount} activeCount={activeCount} />
      <CountTopFilter onClick={getOrders} title="CANCELED" count={canceledCount} activeCount={activeCount} />
      <Wall />

      {retailerSuppliers.length > 1 && (
        <>
          <DropDownFilter
            values={suppliers}
            onChange={(value) => dispatch(setDropshipOrdersSupplierId(value))}
            squareImages
          />
          <Wall />
        </>
      )}

      <ActionButton
        type="download"
        size={25}
        onClick={() => dispatch(dropshipOrdersReport())}
        tooltipContent="Export orders report"
      />
      <Wall />
    </Panel>
  );
}
